import { useState,useContext,useEffect } from "react";
import { useQuery, useMutation } from "@apollo/client";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { closeCompetenceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { CREATE_COMPETENCE_EVALUATION,
         GET_ALL_COMPETENCE_EVALUATION,
         GET_ALL_COMPETENCE_BY_ID, 
         UPDATE_COMPETENCE_EVALUATION } from "../../../Querys/querys";
import {
    Dialog,
    DialogTitle,
    DialogContent,  
    TextField
 } from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";

const ModalCreateCompetenceEvaluation = () => {
    const {state, dispatch} = useContext(PerformanceEvaluationContext);  
    const [nameModal, setNameModal] = useState("")
    const [counterTxt, setCounterTxt] = useState(0);   
    const [buttonDisabled,setButtonDisabled]=useState(false);
    const [update, setUpdate] = useState(false);
    const { data: getCompetenceById } = useQuery(GET_ALL_COMPETENCE_BY_ID, {
      variables: { id: state._id },
      skip: !state._id,
      fetchPolicy: 'no-cache'
    })
    const [initialValuesForm, setInitialValuesForm] = useState(
      {
      nameCompetence: "",     
      DescriptionCompetence:""
    }
  );
  const [createCompetenceEvaluation] = useMutation(CREATE_COMPETENCE_EVALUATION, {
    refetchQueries: [
      { query: GET_ALL_COMPETENCE_EVALUATION }
    ],
 });

 const [updateCompetenceEvaluation] = useMutation(UPDATE_COMPETENCE_EVALUATION, {
  refetchQueries: [
    { query: GET_ALL_COMPETENCE_EVALUATION }
  ],
});

    const counterArea=(e:any)=>{
      setCounterTxt(e.length)
  }    

    useEffect(() => {
      if (state._id === '' || state._id === '0') {
        setNameModal("Crear Competencia")
        setInitialValuesForm({
          nameCompetence: "",     
          DescriptionCompetence:""
        })
        setCounterTxt(0)
        setUpdate(false)
      }
    }, [state._id])

    useEffect(() => {      
      if(getCompetenceById?.GET_ALL_COMPETENCE_BY_ID){
        setUpdate(true)
        setNameModal("Actualizar Competencia")
        setInitialValuesForm({
          nameCompetence: getCompetenceById.GET_ALL_COMPETENCE_BY_ID?.nameCompetence,
          DescriptionCompetence: getCompetenceById.GET_ALL_COMPETENCE_BY_ID?.DescriptionCompetence,
        })
        setCounterTxt(getCompetenceById.GET_ALL_COMPETENCE_BY_ID?.DescriptionCompetence.length)
      }
    }, [getCompetenceById])

    const closeModalPerEv=()=>{
        closeCompetenceEvaluationModal("",false, dispatch)
        formik.resetForm();   
        setCounterTxt(0)
    }

    const validationSchema = () => {               
      return {
        nameCompetence: Yup.string().trim("Obligatorio").required("Obligatorio"),
      }      
    }

    const formik = useFormik({
      initialValues: initialValuesForm,
      enableReinitialize: true,      
      validationSchema: Yup.object(validationSchema()),
      onSubmit: async (formData, { resetForm }) => {  
        const nameCompetence = formData.nameCompetence.trim()
        const descriptionCompetence = formData.DescriptionCompetence.trim()
        let variablesPerformanceEvaluation
        variablesPerformanceEvaluation = {
          ...formData,
          nameCompetence: nameCompetence,
          DescriptionCompetence: descriptionCompetence
        }    
        try {  
          setButtonDisabled(true)
          if(!update) {
            await createCompetenceEvaluation({
              variables: {
                input: variablesPerformanceEvaluation,
              },
            });
            SuccessfulAlert({ text: "Competencia creada correctamente."});
          } else {
            await updateCompetenceEvaluation({
              variables: {
                updateCompetenceEvaluationId:parseInt(state._id),
                input: variablesPerformanceEvaluation
              },
            });
            SuccessfulAlert({ text: "Competencia actualizada correctamente."});
          }
           setButtonDisabled(false)
           closeModalPerEv()
        }
        catch (e) {
        ErrorAlert({ text: 'Ocurrió un error al crear la competencia'});
        console.log("error",e)
        setButtonDisabled(false)
      }
      }  
    });  

  return (
    <>    
    <Dialog 
          open={state.modalCompetenceEvaluation}
           aria-labelledby="form-dialog-title" 
           className="dialogPrestacion"         
           >
        <IconButton aria-label="close" onClick={(()=> {closeModalPerEv() } )}
          sx={{position: 'absolute', right: 8, top: 8,color: (theme) => theme.palette.grey[500], }}
           >
          <CloseIcon />
        </IconButton>     
       <DialogContent  >
       <Form 
          className="containerMdalPrestacion" 
          onSubmit={formik.handleSubmit} 
          >  
        <DialogTitle  className="titleModalPerformanceEval" ><span className="txtTitleModalPerformanceEval">{nameModal}</span></DialogTitle>
        <DialogContent className="oneComponentCompetency">
              <TextField
                type="text"
                name="nameCompetence"
                label="Nombre de la competencia*"
                variant="outlined"
                size="small"
                fullWidth={true}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                inputProps={{ maxLength: 50 }}
                value={formik.values.nameCompetence}
                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                error={formik.touched.nameCompetence && Boolean(formik.errors.nameCompetence)}
                helperText={formik.touched.nameCompetence && formik.errors.nameCompetence}
              />
            </DialogContent>
        <DialogContent className="oneComponentCompetency">   
            <TextField
              id="outlined-multiline-static"
              label="Descripción"
              multiline                  
              name="DescriptionCompetence"
              value={formik.values.DescriptionCompetence}
              onBlur={formik.handleBlur}
              onChange={(e:any)=>{
                formik.handleChange(e);
                counterArea(e.target.value);                                                                
              }} 
              rows={3}
              style = {{width: 465,fontFamily:'Roboto',fontStyle: 'italic' }}
              variant="outlined"
              inputProps={{ maxLength: 350 }}                     
            /> 
            <div className="divCounterArea"><label className="txtConterPres">{`${counterTxt}/350`}</label></div>
          </DialogContent>
          <DialogContent className="twoComponentBtns">
              <div className="containerButtons">
                <div className="containerCancelPreestacion">
                  <button className="btnCancelPrestacion" type="button"
                    onClick={(() => {
                    //  formik.resetForm();
                      closeModalPerEv();                
                    }
                    )}>
                    Cancelar
                  </button>
                </div>
                <div className="containerAddPrestacion">
                  <button className="btnAddPrestacion" type="submit" disabled={buttonDisabled}>
                    <div className="infobtnAddRestriccion">                 
                      <div><span className="txtBtnAdd">Guardar</span> </div>
                    </div>
                  </button>
                </div>
              </div>
          </DialogContent>   
          </Form>    
       </DialogContent>     
    </Dialog>        
    </>
  )
}

export default ModalCreateCompetenceEvaluation

